import Country from "../../slices/master/country/Country"
import State from "../../slices/master/state/State"
import City from "../../slices/master/city/City"
import Category from "../../slices/master/category/Category"
import Unit from "../../slices/master/unit/Unit"
import Pincode from "../../slices/master/pincode/Pincode"

const masterReducer = {
    country: Country,
    state: State,
    city: City,
    category: Category,
    unit: Unit,
    pincode: Pincode,
};

export default masterReducer;